import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
var baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  name: 'jasbwgTabs',
  data() {
    return {
      tabs: [],
      activeIndex: 0,
      list: [],
      querys: {},
      pageIds: {
        'jaxbwg': 300085,
        'jtbwg': 412309
      },
      list1: ['5414592', '6235111', '6235164'],
      list2: ['5414593', '6235182']
    };
  },
  methods: {
    getTabs() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/classifies?appIds=${this.$route.query.appIds || 1556675}&pageId=${this.pageIds[this.$route.query.name] || 300085}&wfwfid=${this.$route.query.wfwid || 44672}`).then(res => {
        let datas = res.data.data.classifies.map(item => {
          return {
            name: item.name,
            cid: item.id,
            url: item.url,
            pid: item.pid,
            introduction: item.introduction,
            showType: item.showType
          };
        });
        this.tabs = datas.filter(d => {
          return d.pid == this.$route.query.cid;
        });
        if (!this.tabs.length) this.tabs = datas.filter(d => {
          return d.cid == this.$route.query.cid;
        });
        if (this.$route.query.title == '藏品鉴赏') {
          this.tabs = this.tabs.splice(1, this.tabs.length - 1);
        }
        this.getDatas();
      });
    },
    toDetail(index) {
      let query = {
        cid: this.tabs[this.activeIndex].cid,
        index: index
      };
      let appIds = this.$route.query.id.split(',');
      if (this.$route.query.pageId) {
        query.pageId = this.$route.query.pageId;
        query.appIds = appIds[this.activeIndex];
      }
      if (this.$route.query.wfwid) {
        query.wfwid = this.$route.query.wfwid;
      }
      this.$router.push({
        name: 'jasbwgDetail',
        query
      });
    },
    getDatas() {
      if (this.tabs[this.activeIndex].showType > 1 && !this.$route.query.pageId) return;
      let classifies = [{
        id: this.tabs[this.activeIndex].cid
      }];
      let appIds = this.$route.query.id.split(',');
      let data = encodeURIComponent(`${JSON.stringify(classifies)}`);
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=${this.$route.query.pageId ? appIds[this.activeIndex] : this.$route.query.id}&pageId=${this.$route.query.pageId || 300085}&wfwfid=${this.$route.query.wfwid || 44672}${this.$route.query.pageId && !this.$route.query.fromClass ? '' : `&classifies=${data}`}&pageSize=40`).then(res => {
        this.list = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
      });
    },
    changeIndex(index) {
      this.activeIndex = index;
      this.getDatas();
    }
  },
  created() {
    document.title = '吉安数字博物馆';
    this.getTabs();
    document.title = this.$route.query.title;
  },
  computed: {}
};